Buyapowa.Controllers.Stats = class Stats {
  constructor(el) {
    this.el = el;
    this.view = new Buyapowa.Views.Stats(this.el);
  }
};
